import { Address } from '../FormFields/Address';
import { ControlButtons } from '../ControlButtons';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { aboveGroundInstallationSchema } from '../../schemas/aboveGroundInstallationSchema';
import { Container } from 'react-bootstrap';

export const AboveGroundInstallation = ({
	currInstallationLocation = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) => {
	const { register, handleSubmit, formState } = useForm({
		resolver: yupResolver(aboveGroundInstallationSchema),
		defaultValues: {
			address: currInstallationLocation.address ?? '',
			city: currInstallationLocation.city ?? '',
			state: currInstallationLocation.state ?? 'UT',
			zip: currInstallationLocation.zip ?? '',
		},
	});

	return (
		<>
			<Container className="component  mt-5">
				<h2 className="mb-4">Where do you want it installed?</h2>
				<Address register={register} error={formState.errors}></Address>
			</Container>
			<Container>
				<ControlButtons
					onNext={handleSubmit(onNext)}
					onPrev={onPrevious}
					onSubmit={onSubmit}
					disablePrev={disablePrev}
					disableNext={disableNext}
					finalStep={finalStep}></ControlButtons>
			</Container>
		</>
	);
};
